import axios from 'axios';
import Config from 'Config';
import { createSignedRequest } from 'utils/createSignedRequest';

export const patchSetCostReportSelection = async (
  projectId,
  { reportPK, selectedRecordIds, selectedInvoiceIds, recordHourUpdates }
) => {
  const apiPath = `report/project/${projectId}/cost-report/selection`;

  const body = {
    reportPK,
    selectedRecordIds,
    selectedInvoiceIds,
    recordHourUpdates: recordHourUpdates || [],
  };

  const request = {
    url: `https://${process.env.REACT_APP_WORK_CALENDAR_API_URL}/${apiPath}`,
    // url: `http://localhost:3001/${apiPath}`,
    host: process.env.REACT_APP_WORK_CALENDAR_API_URL,
    path: apiPath,
    method: 'PATCH',
    region: Config.AWS_REGION,
    service: 'execute-api',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
    data: body,
  };

  const signedRequest = await createSignedRequest(request);
  const response = await axios(signedRequest);

  return response.data;
};
